// extracted by mini-css-extract-plugin
export var alignBaseline = "_f-9";
export var alignCenter = "_f-5";
export var alignFlexEnd = "_f-7";
export var alignFlexStart = "_f-6";
export var alignSelfBaseline = "_f-e";
export var alignSelfCenter = "_f-a";
export var alignSelfFlexEnd = "_f-c";
export var alignSelfFlexStart = "_f-b";
export var alignSelfStretch = "_f-d";
export var alignStretch = "_f-8";
export var column = "_f-2";
export var columnReverse = "_f-4";
export var flex = "_f-0";
export var justifyCenter = "_f-f";
export var justifyFlexEnd = "_f-h";
export var justifyFlexStart = "_f-g";
export var justifySpaceAround = "_f-j";
export var justifySpaceBetween = "_f-i";
export var justifySpaceEvenly = "_f-k";
export var row = "_f-1";
export var rowReverse = "_f-3";
export var wrapNowrap = "_f-m";
export var wrapWrap = "_f-l";
export var wrapWrapReverse = "_f-n";